import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useSeo } from '../hooks/useSeo';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const NOTERRO_URL = 'https://auralune.noterro.com';

export default function Article() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    setArticle(null); setMissing(false);
    axios.get(`${API}/articles/${slug}`).then((r) => setArticle(r.data)).catch(() => setMissing(true));
  }, [slug]);

  useSeo(article && `${article.title} | Aura Lune RMT`, article?.meta_description, article?.keywords);

  return (
    <div className="bg-[#F4EFE7] min-h-screen overflow-x-hidden" data-testid="article-page">
      <Navbar />
      <article className="pt-32 pb-20 max-w-[760px] mx-auto px-6 sm:px-8">
        <Link to="/articles" data-testid="article-back-link"
          className="inline-flex items-center gap-2 text-[12px] text-[#1E1B18]/60 hover:text-[#1E1B18] mb-8">
          <ArrowLeft size={13} /> All articles
        </Link>
        {missing && <p data-testid="article-not-found" className="text-[15px] text-[#1E1B18]/70">This article isn't available.</p>}
        {!article && !missing && <p className="text-[14px] text-[#1E1B18]/50">Loading…</p>}
        {article && (
          <>
            <p className="text-[11px] tracking-[0.3em] text-[#8B7FB8] mb-4">{(article.published_at || '').slice(0, 10)}</p>
            <h1 data-testid="article-title" className="font-serif text-4xl sm:text-5xl text-[#1E1B18] leading-[1.08] mb-6">{article.title}</h1>
            <p className="text-[17px] text-[#1E1B18]/70 leading-relaxed mb-10">{article.excerpt}</p>
            {(article.sections || []).map((s, i) => (
              <section key={i} className="mb-9">
                <h2 className="font-serif text-2xl text-[#1E1B18] mb-4">{s.heading}</h2>
                {(s.paragraphs || []).map((p, j) => (
                  <p key={j} className="text-[15px] text-[#1E1B18]/80 leading-[1.8] mb-4">{p}</p>
                ))}
              </section>
            ))}
            <a href={NOTERRO_URL} target="_blank" rel="noopener noreferrer" data-testid="article-book-btn"
              className="inline-flex bg-[#0F0E0C] hover:bg-[#2A2622] text-[#F4EFE7] px-6 py-3 rounded-full text-[13px] font-medium transition-colors">
              Book with Aura Lune RMT
            </a>
            {!!article.keywords?.length && (
              <p className="mt-12 text-[11px] text-[#1E1B18]/40 leading-relaxed">{article.keywords.join(' · ')}</p>
            )}
          </>
        )}
      </article>
      <Footer />
    </div>
  );
}
